import { render } from "./SpacesGroupsAddMembers.vue?vue&type=template&id=ad2e6a78&ts=true"
import script from "./SpacesGroupsAddMembers.vue?vue&type=script&lang=ts"
export * from "./SpacesGroupsAddMembers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__